module.exports = "/images/Create packages - 1.jpg";